// @flow
import React, { useRef, useState } from 'react'
import classNames from 'classnames'
import Button from '../../../basic/Button'
import { useIntl } from 'gatsby-plugin-intl'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import baseStyles from './FileUpload.scss'
import messages from './FileUpload.lang'

type Props = {
  ...StyleProps,
  name: string
}

const FileUpload = ({ styles, name }: Props) => {
  const { formatMessage } = useIntl()
  const [fileName, setFileName] = useState('')

  const hiddenFileInput = useRef(null)

  const handleClick = () => {
    if (hiddenFileInput && hiddenFileInput.current) {
      hiddenFileInput.current.click()
    }
  }

  const handleChange = event => {
    const fileUploaded = event.target.files[0]
    setFileName(fileUploaded.name)
  }

  return (
    <div className={styles.root}>
      <p className={styles.description}>{formatMessage(messages.description)}</p>
      <div className={styles.row}>
        <Button type="button" styles={styles.btn} color="primary" onClick={handleClick}>
          {formatMessage(messages.btnLabel)}
        </Button>
        {fileName && (
          <div className={styles.fileName}>
            <span className={classNames(styles.fileNameIcon, 'icon-success')} />
            <span className={styles.fileNameValue}>{fileName}</span>
          </div>
        )}
        <input type="file" ref={hiddenFileInput} onChange={handleChange} name={name} className={styles.field} />
      </div>
    </div>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(FileUpload)
